import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivationStart, Router, RouterModule } from '@angular/router';
import { PaymentCart } from '@cargos/sprintpay-models';
import { Subject, filter, map, takeUntil } from 'rxjs';
import { CartBillService } from 'src/app/shared/services';

@Component({
    standalone: true,
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss'],
    imports: [RouterModule, MatButtonModule, MatIconModule, MatBadgeModule],
})
export class CartComponent implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void>;
    public _cart: PaymentCart[];
    public showCartIcon = true;

    @Input() cartAllowedRoutes: string[];
    @Input() cartDisallowedRoutes: string[];

    constructor(
        private router: Router,
        private cartBillService: CartBillService
    ) {
        this.unsubscribe$ = new Subject<void>();
    }

    ngOnInit(): void {
        this.subscribeAvailablesRouteToShowIconCart();
        this.subscribeCart();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    subscribeAvailablesRouteToShowIconCart(): void {
        this.router.events
            .pipe(
                filter((event) => event instanceof ActivationStart),
                map((event) => event as ActivationStart),
                map((event) => this.displayCartIcon(event.snapshot.routeConfig?.path || '')),
                takeUntil(this.unsubscribe$)
            )
            .subscribe((isAvailable: boolean) => {
                this.showCartIcon = isAvailable;
            });
    }

    displayCartIcon(url: string): boolean {
        return !this.cartDisallowedRoutes.find((element) => element === url);
    }

    subscribeCart(): void {
        this.cartBillService
            .getCart$()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((cart) => {
                this._cart = cart;
            });
    }
}
